import { render, staticRenderFns } from "./UserProfilePage.vue?vue&type=template&id=679cd53c&scoped=true&"
import script from "./UserProfilePage.vue?vue&type=script&lang=js&"
export * from "./UserProfilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679cd53c",
  null
  
)

export default component.exports